// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1EkFn","colBig":"styles_colBig__29GEJ","colSmall":"styles_colSmall__2Dnh8"};